module.exports = __webpack_public_path__ + "static/Selfie-Sign-17ec196b21c5a76b69c5a0c51ca2fc85.jpg";